import { AddonGroupSubItemType, AddonGroupType, SubItemType } from "../types";
import {
  menuEntityMatchesId,
  resolveAddonGroupUuid,
  resolveAddonSubItemUuid,
  resolveSubItemUuid,
} from "./entityKeys";

/** @deprecated Prefer resolveAddonGroupUuid */
export function resolveAddonGroupId(group: AddonGroupType): string | undefined {
  return resolveAddonGroupUuid(group);
}

export function addonGroupMatchesId(
  group: AddonGroupType,
  addonGroupId: string
): boolean {
  return menuEntityMatchesId(group, addonGroupId);
}

/** @deprecated Prefer resolveAddonSubItemUuid */
export function resolveAddonSubItemId(
  addonGroupSubItem: AddonGroupSubItemType
): string | undefined {
  return resolveAddonSubItemUuid(addonGroupSubItem);
}

/** @deprecated Prefer resolveSubItemUuid */
export function resolveAddonSubItemIdFromSubItem(
  subItem?: SubItemType
): string | undefined {
  if (!subItem) {
    return undefined;
  }

  return resolveSubItemUuid(subItem);
}

export function addonSubItemMatchesId(
  addonGroupSubItem: AddonGroupSubItemType,
  subItemId: string
): boolean {
  return (
    (addonGroupSubItem.subItem != null &&
      menuEntityMatchesId(addonGroupSubItem.subItem, subItemId)) ||
    menuEntityMatchesId(addonGroupSubItem, subItemId)
  );
}
